export type PassportData = {
  id: number;
  guest_id?: number | null;
  last_name?: string | null;
  first_name?: string | null;
  country?: string | null;
  nationality?: string | null;
  birth_date?: string | null;
  expiry_date?: string | null;
  gender?: string | null;
  document_type?: string | null;
  document_number?: string | null;
  optional_data?: string | null;
  birth_date_hash?: string | null;
  expiry_date_hash?: string | null;
  document_number_hash?: string | null;
  final_hash?: string | null;
  is_confirmed?: boolean;
  is_confirmed_by_guest?: boolean;
  rejected_at?: string | null;
  rejected_by?: string | null;
  rejected_reason?: string | null;
};

export default class Passport {
  public id: number;
  public guestId: number | null;
  public lastName: string | null;
  public firstName: string | null;
  public country: string | null;
  public nationality: string | null;
  public birthDate: string | null;
  public expiryDate: string | null;
  public gender: string | null;
  public documentType: string | null;
  public documentNumber: string | null;
  public optionalData: string | null;
  public birthDateHash: string | null;
  public expiryDateHash: string | null;
  public documentNumberHash: string | null;
  public finalHash: string | null;
  public isConfirmed: boolean;
  public isConfirmedByGuest: boolean;
  public rejectedAt: string | null;
  public rejectedBy: string | null;
  public rejectedReason: string | null;

  constructor(data: PassportData) {
    this.id = data.id;
    this.guestId = data.guest_id ?? null;
    this.lastName = data.last_name ?? null;
    this.firstName = data.first_name ?? null;
    this.country = data.country ?? null;
    this.nationality = data.nationality ?? null;
    this.birthDate = data.birth_date ?? null;
    this.expiryDate = data.expiry_date ?? null;
    this.gender = data.gender ?? null;
    this.documentType = data.document_type ?? null;
    this.documentNumber = data.document_number ?? null;
    this.optionalData = data.optional_data ?? null;
    this.birthDateHash = data.birth_date_hash ?? null;
    this.expiryDateHash = data.expiry_date_hash ?? null;
    this.documentNumberHash = data.document_number_hash ?? null;
    this.finalHash = data.final_hash ?? null;
    this.isConfirmed = data.is_confirmed ?? false;
    this.isConfirmedByGuest = data.is_confirmed_by_guest ?? false;
    this.rejectedAt = data.rejected_at ?? null;
    this.rejectedBy = data.rejected_by ?? null;
    this.rejectedReason = data.rejected_reason ?? null;
  }

  toDTO(): PassportData {
    return {
      id: this.id,
      guest_id: this.guestId,
      last_name: this.lastName,
      first_name: this.firstName,
      country: this.country,
      nationality: this.nationality,
      birth_date: this.birthDate,
      expiry_date: this.expiryDate,
      gender: this.gender,
      document_type: this.documentType,
      document_number: this.documentNumber,
      optional_data: this.optionalData,
      birth_date_hash: this.birthDateHash,
      expiry_date_hash: this.expiryDateHash,
      document_number_hash: this.documentNumberHash,
      final_hash: this.finalHash,
      is_confirmed: this.isConfirmed,
      is_confirmed_by_guest: this.isConfirmedByGuest,
      rejected_at: this.rejectedAt,
      rejected_by: this.rejectedBy,
      rejected_reason: this.rejectedReason
    };
  }
}
